/**
 * 意见反馈接口。契约（apps/api/src/routes/me.route.ts:66）：
 *   POST /feedback  { content: string }  → 201 { id: string }
 *
 * 注意：后端 feedbackBody 只接受 content 一个字段（zod 对象默认会**静默丢弃**未知字段）。
 * 因此「类型」这类前端标签不会作为独立字段提交，而是由调用方拼进 content 前缀，
 * 避免出现"界面选了类型、后端其实没存"的假象。
 */
import { api } from './client.js';
import type { FeedbackSubmitDto } from './types.js';

export const feedbackApi = {
  /** 提交一条反馈（需登录）→ { id } */
  submit: (content: string): Promise<FeedbackSubmitDto> => api.post<FeedbackSubmitDto>('/feedback', { content }),
};